import inst from '@/backend/axios-instances'

const instance = inst.baseInstance
const resource = '/users'

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    return instance.post(resource, data, { params: parameters });
  }
}